<script>
import DemoBody from '@/components/demos/DemoBody'
import DemoBodyResult from '@/components/demos/DemoBodyResult'
import Tags from '@/components/tags/Tags'
import TagItem from '@/components/tags/TagItem'

export default {
  data() {
    return {
      imageDimensions: false,
      isLoading: false
    }
  },
  props: {
    imageUrl: [Boolean, String],
    sampleImages: Array,
    result: Object,
    tagKey: String
  },
  emits: ['setSampleImage', 'reset'],
  created() {
    this.getImageDimensions()
  },
  watch: {
    imageUrl() {
      this.getImageDimensions()
    }
  },
  methods: {
    getImageDimensions() {
      const img = new Image()
      this.imageDimensions = false
      img.onload = ()=> {
        this.imageDimensions = {
          width: img.naturalWidth,
          height: img.naturalHeight
        }
      }
      img.src = this.imageUrl
    },
  },
  components: {
    DemoBodyResult,
    Tags,
    TagItem,
    DemoBody
  }
}
</script>